import React from 'react';
import styles from './styles';

const InfiniteLoading = () =>
  <div className={styles.loadingLabel}>
    Loading additional results...
  </div>;

export default InfiniteLoading;



// WEBPACK FOOTER //
// ./client/app/shared/components/InfiniteLoading/index.jsx